function empty(){}

let map = {};

const def_map = {
    onChapter : empty,
    onJoin : empty,
    onLimitExceeded : empty,
    onNoSubCTA : empty,
    onNoSolutionCTA : empty,
    onNetworkErrorCTA : empty,
    onContentUpdate : empty,
    onProblemOpened : empty,
    onProblemLoaded : empty,
    onReviewClicked : empty,
    onBookmarkClicked : empty,
    onMobileClicked: empty,
    onAccessRestricted : empty,
    onNoSolutionAccess : empty
};

export function trigger(event, params){
    let name = 'on' + event.replace(/^(.)(.*)/,(m, first,word)=>{
        return first.toUpperCase() + word;
    });

    if (map[name]==empty) return;

    try {
        map[name](params);
    }catch(e){
        console.error(e);
    }
}

export function register(events){
    for (let name in events){
        if (name in map) map[name] = events[name];
    }
}

export function reset(){
    map = {
        ...def_map
    };
}

reset();



// WEBPACK FOOTER //
// ./src/helpers/events.js